
import { canvasRaw, canvasInspection, openSheetArrayInfo, openSheetIsReadOnly, getWSModel } from "./ModelHelpers.js";
import { getFastSim } from "../Simulator/Simulator.js";
import { makeText, getTextWidthInPixels, Text$ as Text$_2, defaultText } from "../Common/DrawHelpers.js";
import { createAtom, compare, comparePrimitives, defaultOf, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { probeLabelForWire } from "./WaveSim/WaveSimSelect.js";
import { min, max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { CSSProp, HTMLAttr, DOMAttr, SVGAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { head, tail, isEmpty, ofArray, append, tryFind, empty, singleton } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { toArray, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { rightSectionStyle, canvasVisibleStyleList, minEditorWidth, minViewerWidth, getHeaderHeight, belowHeaderStyle, Constants_dividerBarWidth, rightSectionWidthViewerDefault, canvasSmallMenuStyle, canvasSmallButtonStyle, canvasTopOverlayStyle, librarySheetColours, arraySheetColours, canvasSheetKindStyle, canvasReadOnlyBannerStyle } from "./Style.js";
import { findLibraries, isLibraryProject } from "../Interface/ComponentLibraries.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList, exists } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { DrawModelType_SymbolT_ThemeType, DrawModelType_BusWireT_WireType, DrawModelType_SheetT_KeyboardMsg, DrawModelType_SheetT_Msg } from "../Model/DrawModelType.js";
import { ScrollbarMouseAction, WaveSimModel, Model, DragMode, TopMenu, Notifications, PopupDialogData, SidecarSessionState, SimSubTab, RightTab, Pane, CircuitCheck as CircuitCheck_1, UserData as UserData_1, Msg } from "../Model/ModelType.js";
import { Option, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Modifier_IModifier, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { viewPopup, PasteArray_pasteArrayPopup } from "./UIPopups.js";
import { init as init_1 } from "../DrawBlock/SheetUpdate.js";
import { tryFind as tryFind_1, empty as empty_2 } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { tTTypeInit } from "./TruthTable/TruthTableUpdate.js";
import { empty as empty_3 } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { viewTruthTable } from "./TruthTable/TruthTableView.js";
import { viewWaveSim } from "./WaveSim/WaveSimTop.js";
import { h4 } from "../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { viewSimulation } from "./StepSimulationTop.js";
import { extractComponents, displayedComponent } from "../DrawBlock/SymbolUpdate.js";
import { viewSelectedComponent } from "./SelectedComponentView.js";
import { Tab_Option, tab, Option as Option_1, tabs } from "../fable_modules/Fulma.3.0.0/Components/Tabs.fs.js";
import { viewBuild } from "./BuildView.js";
import { viewDragGhost, viewCatalogue } from "./CatalogueView.js";
import { Operators_IsNull } from "../fable_modules/fable-library-js.5.13.0/FSharp.Core.js";
import { getTimeMs } from "../Common/TimeHelpers.js";
import { delayedDispatch, debugLevel } from "../Interface/JSHelpers.js";
import { screenWidth } from "./WaveSim/WaveSimStyle.js";
import { CursorType__Text } from "../Common/CommonTypes.js";
import { extractConnections } from "../DrawBlock/BusWire.js";
import { viewTopMenu, viewNoProjectMenu } from "./TopMenuView.js";
import { viewNotifications } from "./Notifications.js";
import { updateWSModel, getWSModel as getWSModel_1 } from "./ModelHelpers.js";
import { singleWaveWidth, valuesColumnSize, calcNamesColWidth } from "./WaveSim/WaveSimStyle.js";
import { viewSymbolWidth, waveTableRightGap, rightMargin, leftMargin } from "./WaveSim/WaveSimTypes.js";
import { Constants_dividerBarWidth as Constants_dividerBarWidth_1 } from "./Style.js";
import { validateScrollBarInfo } from "./WaveSim/WaveSimNavigation.js";
import { view } from "../DrawBlock/SheetDisplay.js";
import { hoveredHighlight } from "./WaveSim/WaveSimWaveforms.js";

export const Constants_memoryCheckMinTime = 500;

function Probe_source(model) {
    const ws = getWSModel(model);
    if (ws.State.tag === 5) {
        if (model.SimulateInRenderer) {
            return [getFastSim(), ws.CursorExactClkCycle, ws.Radix];
        }
        else {
            return [getFastSim(), ws.CursorExactClkCycle, ws.Radix];
        }
    }
    else {
        const matchValue_1 = model.CurrentStepSimulationStep;
        let matchResult, simData;
        if (matchValue_1 != null) {
            const copyOfStruct = matchValue_1;
            if (copyOfStruct.tag === 0) {
                matchResult = 0;
                simData = copyOfStruct.fields[0];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return [simData.FastSim, simData.ClockTickNumber, simData.NumberBase];
            default:
                return undefined;
        }
    }
}

function Probe_labelFontSize(model) {
    return getWSModel(model).WSConfig.FontSize;
}

function Probe_labelFont(size) {
    return new Text$_2("start", `${size}px`, defaultText.FontWeight, "helvetica", "#443300", defaultText.UserSelect, "middle");
}

function Probe_visibleXSpan(zoom) {
    const matchValue = document.getElementById("Canvas");
    if (equals(matchValue, defaultOf())) {
        return undefined;
    }
    else if (matchValue.clientWidth <= 0) {
        return undefined;
    }
    else {
        const canvas_2 = matchValue;
        return [canvas_2.scrollLeft / zoom, (canvas_2.scrollLeft + canvas_2.clientWidth) / zoom];
    }
}

/**
 * A label drawn beside the cursor giving the value on the wire under it. Empty unless a
 * simulation of this sheet's design is running and the mouse is resting on a wire whose value
 * that simulation knows.
 */
export function Probe_view(model) {
    let props_2, children_2, props;
    const matchValue = model.Sheet.HoveredWire;
    const matchValue_1 = Probe_source(model);
    let matchResult, cid, cycle, fs, radix;
    if (matchValue != null) {
        if (matchValue_1 != null) {
            if (model.Sheet.Action.tag === 11) {
                matchResult = 0;
                cid = matchValue;
                cycle = matchValue_1[1];
                fs = matchValue_1[0];
                radix = matchValue_1[2];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const matchValue_4 = probeLabelForWire(model, fs, cycle, radix, model.Sheet.Wire, cid);
            if (matchValue_4 != null) {
                const text = matchValue_4;
                const pos = model.Sheet.LastMousePos;
                const scale = 1 / model.Sheet.Zoom;
                const fontSize = Probe_labelFontSize(model);
                const padding = 5 * scale;
                const w = (getTextWidthInPixels(Probe_labelFont(fontSize), text) * scale) + (2 * padding);
                const h = (fontSize + 9) * scale;
                const y = (pos.Y - h) - (6 * scale);
                let x;
                const preferred = pos.X + (12 * scale);
                const matchValue_5 = Probe_visibleXSpan(model.Sheet.Zoom);
                if (matchValue_5 != null) {
                    const margin = 4 * scale;
                    x = max(matchValue_5[0] + margin, min((matchValue_5[1] - w) - margin, preferred));
                }
                else {
                    x = preferred;
                }
                return singleton((props_2 = [["style", {
                    pointerEvents: "none",
                }]], (children_2 = [(props = [new SVGAttr(/* X */ 44, [x]), new SVGAttr(/* Y */ 57, [y]), new SVGAttr(/* Width */ 41, [w]), new SVGAttr(/* Height */ 14, [h]), new SVGAttr(/* Rx */ 25, [3 * scale]), new SVGAttr(/* Fill */ 6, ["#fffbe6"]), new SVGAttr(/* Stroke */ 30, ["#b0a060"]), new SVGAttr(/* StrokeWidth */ 36, [0.8 * scale])], react.createElement("rect", keyValueList(props, 1))), makeText(x + padding, y + (h / 2), text, Probe_labelFont(fontSize * scale))], react.createElement("g", keyValueList(props_2, 1), ...children_2))));
            }
            else {
                return empty();
            }
        }
        default:
            return empty();
    }
}

function readOnlyBanner(model) {
    let children, option_1, matchValue_1, compName, libName;
    const matchValue = model.CurrentProj;
    let matchResult, p_1;
    if (matchValue != null) {
        if (openSheetIsReadOnly(model)) {
            matchResult = 0;
            p_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return singleton((children = [concat("👁 ", defaultArg((option_1 = tryFind((ldc) => (ldc.Name === p_1.OpenFileName), p_1.LoadedComponents), (option_1 != null) ? ((matchValue_1 = option_1.Form, (matchValue_1 != null) ? ((matchValue_1.tag === 1) ? ((compName = matchValue_1.fields[1], (libName = matchValue_1.fields[0], concat(compName, " · ", libName, " library")))) : undefined) : undefined)) : undefined), p_1.OpenFileName), " — read-only, and open only until this project is closed")], react.createElement("div", keyValueList([canvasReadOnlyBannerStyle], 1), ...children)));
        default:
            return empty();
    }
}

function openSheetIsLibraryComponent(model) {
    const matchValue = model.CurrentProj;
    if (matchValue != null) {
        const p = matchValue;
        if (isLibraryProject(p)) {
            return true;
        }
        else {
            return exists((ldc_1) => {
                const matchValue_1 = ldc_1.Form;
                let matchResult;
                if (matchValue_1 != null) {
                    if (matchValue_1.tag === 1) {
                        matchResult = 0;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return true;
                    default:
                        return false;
                }
            }, toArray(tryFind((ldc) => (ldc.Name === p.OpenFileName), p.LoadedComponents)));
        }
    }
    else {
        return false;
    }
}

function sheetKindLegend(model) {
    let option_1;
    const chip = (colours, text) => {
        const props = [canvasSheetKindStyle(colours)];
        return react.createElement("div", keyValueList(props, 1), text);
    };
    return append(ofArray(toArray((option_1 = openSheetArrayInfo(model), (option_1 != null) ? chip(arraySheetColours, `array sheet × ${option_1.Copies}`) : undefined))), openSheetIsLibraryComponent(model) ? singleton(chip(librarySheetColours, "library component sheet")) : empty());
}

/**
 * Everything laid over the top of the canvas that describes the sheet below it, stacked in the
 * one container so that the legend does not have to know how tall the banner is - or whether
 * there is one.
 */
export function viewCanvasTopOverlay(model) {
    const matchValue = append(readOnlyBanner(model), sheetKindLegend(model));
    if (isEmpty(matchValue)) {
        return defaultOf();
    }
    else {
        const props = [canvasTopOverlayStyle(model)];
        return react.createElement("div", keyValueList(props, 1), ...matchValue);
    }
}

export function viewOnDiagramButtons(model, dispatch) {
    const dispatch_1 = (arg) => {
        dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* KeyPress */ 2, [arg])]));
    };
    const readOnly = openSheetIsReadOnly(model);
    const children = toList(delay(() => {
        const canvasBut = (func, label) => button(ofArray([new Option(/* Props */ 17, [ofArray([canvasSmallButtonStyle, new DOMAttr(/* OnClick */ 40, [(ev) => {
            if (!readOnly) {
                func(ev);
            }
        }])])]), new Option(/* Disabled */ 16, [readOnly]), new Option(/* Modifiers */ 20, [ofArray([new Modifier_IModifier(/* TextColor */ 1, [Color_IColor.IsLight]), new Modifier_IModifier(/* BackgroundColor */ 0, [Color_IColor.IsSuccess])])])]), singleton(label));
        return append_1(singleton_1(canvasBut((_arg) => {
            dispatch_1(DrawModelType_SheetT_KeyboardMsg.CtrlZ);
        }, "< undo")), delay(() => append_1(singleton_1(canvasBut((_arg_1) => {
            dispatch_1(DrawModelType_SheetT_KeyboardMsg.CtrlY);
        }, "redo >")), delay(() => append_1(singleton_1(canvasBut((_arg_2) => {
            dispatch_1(DrawModelType_SheetT_KeyboardMsg.CtrlC);
        }, "copy")), delay(() => append_1(singleton_1(canvasBut((_arg_3) => {
            dispatch_1(DrawModelType_SheetT_KeyboardMsg.CtrlV);
        }, "paste")), delay(() => ((model.Sheet.OfferPasteArray && !readOnly) ? singleton_1(canvasBut((_arg_4) => {
            PasteArray_pasteArrayPopup(model, dispatch);
        }, "paste array")) : empty_1())))))))));
    }));
    return react.createElement("div", keyValueList([canvasSmallMenuStyle], 1), ...children);
}

export function init() {
    const WindowWidth = self.innerWidth;
    const UserData = new UserData_1(undefined, undefined, undefined, true, DrawModelType_BusWireT_WireType.Radial, DrawModelType_SymbolT_ThemeType.Colourful);
    const Sheet = init_1()[0];
    const CircuitCheck = new CircuitCheck_1(undefined, false);
    return new Model(WindowWidth, Pane.LeftPane, undefined, UserData, empty_2({
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }), undefined, empty(), undefined, Sheet, false, 0, undefined, [empty(), empty()], [empty(), empty()], [empty(), empty()], 1, undefined, undefined, undefined, tTTypeInit, RightTab.Catalogue, SimSubTab.StepSim, CircuitCheck, [[empty(), empty()], empty()], [empty(), empty()], undefined, false, undefined, undefined, undefined, empty_3({
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }), findLibraries(), undefined, "", undefined, false, SidecarSessionState.NoSession, undefined, empty_2({
        Compare: (x_2, y_2) => (compare(x_2, y_2) | 0),
    }), 0, 0, undefined, undefined, undefined, undefined, 0, undefined, 0, false, 0, false, false, empty_3({
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }), undefined, undefined, undefined, undefined, new PopupDialogData(undefined, undefined, undefined, empty_2({
        Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
    }), undefined, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, empty(), false, undefined, undefined, undefined), new Notifications(undefined, undefined, undefined, undefined, undefined, undefined), TopMenu.Closed, false, DragMode.DragModeOff, rightSectionWidthViewerDefault, false, empty(), undefined, false, undefined);
}

export function viewSimSubTab(canvasState_, canvasState__1, model, dispatch) {
    const canvasState = [canvasState_, canvasState__1];
    const matchValue = model.SimSubTabVisible;
    switch (matchValue.tag) {
        case 1: {
            const props_2 = [["style", {
                width: "90%",
                marginLeft: "5%",
                marginTop: "15px",
            }]];
            const children_2 = [viewTruthTable(canvasState[0], canvasState[1], model, dispatch)];
            return react.createElement("div", keyValueList(props_2, 1), ...children_2);
        }
        case 2: {
            const props_4 = [["style", {
                width: "100%",
                marginTop: "15px",
                height: "calc(100% - 72px)",
            }]];
            const children_4 = [viewWaveSim(canvasState[0], canvasState[1], model, dispatch)];
            return react.createElement("div", keyValueList(props_4, 1), ...children_4);
        }
        default: {
            const props = [["style", {
                width: "90%",
                marginLeft: "5%",
                marginTop: "15px",
                height: "calc(100% - 51px)",
                display: "flex",
                flexDirection: "column",
            }]];
            const children = [h4(empty())(singleton("Step Simulation")), viewSimulation(canvasState[0], canvasState[1], model, dispatch)];
            return react.createElement("div", keyValueList(props, 1), ...children);
        }
    }
}

function viewRightTab(canvasState_, canvasState__1, model, dispatch) {
    let matchValue_3, proj, text, props_4, props_16, props;
    const canvasState = [canvasState_, canvasState__1];
    const pane = model.RightPaneTabVisible;
    switch (pane.tag) {
        case 0: {
            let patternInput;
            const matchValue = model.Sheet.SelectedComponents;
            const matchValue_1 = model.CurrentProj;
            patternInput = (!isEmpty(matchValue) ? (isEmpty(tail(matchValue)) ? ["Component properties", (matchValue_3 = displayedComponent(model.Sheet.Wire.Symbol, head(matchValue)).Type, (matchValue_3.tag === 26) ? ((matchValue_3.fields[0].Form != null) ? ((matchValue_3.fields[0].Form.tag === 1) ? undefined : concat("One instance of sheet ", matchValue_3.fields[0].Name, ". These values apply to this instance only.")) : concat("One instance of sheet ", matchValue_3.fields[0].Name, ". These values apply to this instance only.")) : undefined)] : ["Component properties", undefined]) : ((matchValue_1 == null) ? ["Sheet properties", undefined] : ((proj = matchValue_1, [concat("Sheet properties — ", proj.OpenFileName), "Properties of the open sheet. Select a component for its own properties."]))));
            const blurb_1 = patternInput[1];
            const props_6 = [new HTMLAttr(/* Id */ 99, ["PropertiesPane"]), ["style", {
                width: "90%",
                marginLeft: "5%",
                marginTop: "15px",
                height: "calc(100% - 15px)",
                display: "flex",
                flexDirection: "column",
            }]];
            const children_6 = [h4(empty())(singleton(patternInput[0])), (blurb_1 != null) ? ((text = blurb_1, (props_4 = [["style", {
                marginBottom: "15px",
                fontSize: "12px",
            }]], react.createElement("div", keyValueList(props_4, 1), text)))) : defaultOf(), viewSelectedComponent(model, dispatch)];
            return react.createElement("div", keyValueList(props_6, 1), ...children_6);
        }
        case 2: {
            const subtabs = tabs(ofArray([Option_1.IsFullWidth, Option_1.IsBoxed, new Option_1(/* CustomClass */ 7, ["rightSectionTabs"]), new Option_1(/* Props */ 8, [singleton(["style", {
                margin: 0,
            }])])]), [tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(model.SimSubTabVisible, SimSubTab.StepSim)])), singleton(react.createElement("a", {
                onClick: (_arg) => {
                    dispatch(new Msg(/* ChangeSimSubTab */ 34, [SimSubTab.StepSim]));
                },
            }, "Step Simulation"))), tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(model.SimSubTabVisible, SimSubTab.TruthTable)])), singleton(react.createElement("a", {
                onClick: (_arg_1) => {
                    dispatch(new Msg(/* ChangeSimSubTab */ 34, [SimSubTab.TruthTable]));
                },
            }, "Truth Table"))), tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(model.SimSubTabVisible, SimSubTab.WaveSim)])), singleton(react.createElement("a", {
                onClick: (_arg_2) => {
                    dispatch(new Msg(/* ChangeSimSubTab */ 34, [SimSubTab.WaveSim]));
                },
            }, "Wave Simulation")))]);
            const props_14 = [new HTMLAttr(/* Id */ 99, ["RightSelection2"]), ["style", {
                height: "100%",
            }]];
            const children_14 = [subtabs, viewSimSubTab(canvasState[0], canvasState[1], model, dispatch)];
            return react.createElement("div", keyValueList(props_14, 1), ...children_14);
        }
        case 3: {
            const props_18 = [["style", {
                width: "90%",
                marginLeft: "5%",
                marginTop: "15px",
            }]];
            const children_18 = [h4(empty())(singleton("Build")), (props_16 = [["style", {
                marginBottom: "15px",
            }]], react.createElement("div", keyValueList(props_16, 1), "Compile your design and upload it to one of the supported devices")), viewBuild(model, dispatch)];
            return react.createElement("div", keyValueList(props_18, 1), ...children_18);
        }
        default: {
            const props_2 = [["style", {
                width: "90%",
                marginLeft: "5%",
                marginTop: "15px",
                height: "calc(100% - 15px)",
            }]];
            const children_2 = [h4(empty())(singleton("Catalogue")), (props = [["style", {
                marginBottom: "15px",
            }]], react.createElement("div", keyValueList(props, 1), "Drag components to sheet, or click and click to drop. Hover for details.")), viewCatalogue(model, dispatch)];
            return react.createElement("div", keyValueList(props_2, 1), ...children_2);
        }
    }
}

/**
 * Draggable vertivcal bar used to divide Wavesim window from Diagram window
 */
export function dividerbar(model, dispatch) {
    const isDraggable = equals(model.RightPaneTabVisible, RightTab.Simulation) && (equals(model.SimSubTabVisible, SimSubTab.WaveSim) ? true : equals(model.SimSubTabVisible, SimSubTab.TruthTable));
    const props = [["style", keyValueList(append(ofArray([Operators_IsNull(document.getElementById("RightSection")) ? (new CSSProp(/* Height */ 189, ["100%"])) : (new CSSProp(/* Height */ 189, ["100%"])), new CSSProp(/* Float */ 144, ["left"])]), isDraggable ? ofArray([new CSSProp(/* BackgroundColor */ 21, ["grey"]), new CSSProp(/* Cursor */ 123, ["ew-resize"]), new CSSProp(/* Width */ 395, [Constants_dividerBarWidth])]) : ofArray([new CSSProp(/* BackgroundColor */ 21, ["lightgray"]), new CSSProp(/* Width */ 395, ["2px"]), new CSSProp(/* Height */ 189, ["100%"])])), 1)], new DOMAttr(/* OnMouseDown */ 51, [(ev) => {
        const dividerDragMode = model.DividerDragMode;
        const dispatch_1 = dispatch;
        dispatch_1(Msg.SelectionHasChanged);
        if (dividerDragMode.tag === 1) {
            dispatch_1(new Msg(/* SetDragMode */ 88, [new DragMode(/* DragModeOn */ 0, [~~ev.clientX])]));
        }
    }])];
    return react.createElement("div", keyValueList(props, 1));
}

export function viewRightTabs(canvasState_, canvasState__1, model, dispatch) {
    let props_8, children_8;
    const canvasState = [canvasState_, canvasState__1];
    const rightPanelVisible = model.RightPaneTabVisible;
    let scrollType;
    if (equals(model.RightPaneTabVisible, RightTab.Transition)) {
        dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Catalogue]));
        scrollType = "clip";
    }
    else {
        scrollType = "auto";
    }
    const buildTab = model.BuildVisible ? tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(rightPanelVisible, RightTab.Build)])), singleton(react.createElement("a", {
        onClick: (_arg) => {
            if (!equals(rightPanelVisible, RightTab.Simulation)) {
                dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Build]));
            }
        },
    }, "Build"))) : defaultOf();
    const props_10 = [new HTMLAttr(/* Id */ 99, ["RightSelection"]), ["style", {
        height: "100%",
        overflowY: "visible",
    }]];
    const children_10 = [tabs(ofArray([Option_1.IsFullWidth, Option_1.IsBoxed, new Option_1(/* CustomClass */ 7, ["rightSectionTabs"]), new Option_1(/* Props */ 8, [singleton(["style", {
        margin: 0,
    }])])]), [tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(rightPanelVisible, RightTab.Catalogue)])), singleton(react.createElement("a", {
        onClick: (_arg_1) => {
            dispatch(new Msg(/* ChangeRightTab */ 33, [equals(model.RightPaneTabVisible, RightTab.Simulation) ? RightTab.Transition : RightTab.Catalogue]));
        },
    }, "Catalogue"))), tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(rightPanelVisible, RightTab.Properties)])), singleton(react.createElement("a", {
        onClick: (_arg_2) => {
            dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Properties]));
        },
    }, "Properties"))), tab(singleton(new Tab_Option(/* IsActive */ 0, [equals(rightPanelVisible, RightTab.Simulation)])), singleton(react.createElement("a", {
        onClick: (_arg_3) => {
            dispatch(new Msg(/* ChangeRightTab */ 33, [RightTab.Simulation]));
        },
    }, "Simulations"))), buildTab]), (props_8 = [new HTMLAttr(/* Id */ 99, ["TabBody"]), belowHeaderStyle("36px", scrollType)], (children_8 = [viewRightTab(canvasState[0], canvasState[1], model, dispatch)], react.createElement("div", keyValueList(props_8, 1), ...children_8)))];
    return react.createElement("div", keyValueList(props_10, 1), ...children_10);
}

export let lastDragModeOn = createAtom(false);

export let lastMemoryCheckTime = createAtom(undefined);

/**
 * Top-level application view: as react components that create a react virtual-DOM
 */
export function displayView(model, dispatch) {
    let topMenu;
    const time = getTimeMs();
    if ((time - defaultArg(lastMemoryCheckTime(), 0)) > Constants_memoryCheckMinTime) {
        lastMemoryCheckTime(time);
        dispatch(Msg.CheckMemory);
    }
    if (debugLevel() > 0) {
        window.issie = {
            canvas: () => canvasInspection(model),
            raw: () => canvasRaw(model),
        };
    }
    const matchValue = ~~self.innerWidth | 0;
    ~~self.innerHeight;
    const windowX = matchValue | 0;
    const dividerDragMode = model.DividerDragMode;
    const wsViewerWidth = model.WaveSimViewerWidth | 0;
    if (wsViewerWidth > (screenWidth() - 10)) {
        dispatch(new Msg(/* SetViewerWidth */ 99, [~~screenWidth() - 10]));
    }
    const headerHeight = getHeaderHeight();
    const cursorText = CursorType__Text(model.Sheet.CursorType);
    const conns = extractConnections(model.Sheet.Wire);
    const canvasState = [extractComponents(model.Sheet.Wire.Symbol), conns];
    let offsetOpt;
    const option_3 = model.WaveSimSheet;
    if (option_3 != null) {
        const option_1 = tryFind_1(option_3, model.WaveSim);
        offsetOpt = ((option_1 != null) ? option_1.ScrollbarTbOffset : undefined);
    }
    else {
        offsetOpt = undefined;
    }
    const matchValue_2 = model.Spinner;
    if (matchValue_2 == null) {
    }
    else {
        dispatch(new Msg(/* UpdateModel */ 41, [matchValue_2]));
    }
    if (equals(model.CurrentProj, undefined)) {
        const children = [viewNoProjectMenu(model, dispatch), viewPopup(model, dispatch), viewNotifications(model, dispatch)];
        return react.createElement("div", {
            id: "OpenProject",
        }, ...children);
    }
    else if (equals(model.TopMenuOpenState, TopMenu.TransientClosed)) {
        delayedDispatch(dispatch, 1000, new Msg(/* SetTopMenu */ 85, [TopMenu.Closed]));
        return react.createElement("div", {});
    }
    else {
        const props_10 = [new HTMLAttr(/* Id */ 99, ["WholeApp"]), new DOMAttr(/* OnMouseMove */ 54, [(ev) => {
            if (ev.buttons === 1) {
                dispatch(Msg.SelectionHasChanged);
            }
            const matchValue_3 = ev.buttons;
            let matchResult, pos, pos_1;
            if (dividerDragMode.tag === 0) {
                if (matchValue_3 === 1) {
                    matchResult = 0;
                    pos = dividerDragMode.fields[0];
                }
                else {
                    matchResult = 2;
                }
            }
            else {
                matchResult = 2;
            }
            switch (matchResult) {
                case 0: {
                    const newWidth = ((wsViewerWidth - ~~ev.clientX) + pos) | 0;
                    let w;
                    const e_2 = max(minViewerWidth, newWidth) | 0;
                    w = min(windowX - minEditorWidth(), e_2);
                    dispatch(new Msg(/* SetDragMode */ 88, [new DragMode(/* DragModeOn */ 0, [(~~ev.clientX - w) + newWidth])]));
                    dispatch(new Msg(/* SetViewerWidth */ 99, [w]));
                    break;
                }
                case 1: {
                    let w_1;
                    const e_5 = max(minViewerWidth, (wsViewerWidth - ~~ev.clientX) + pos_1) | 0;
                    w_1 = min(windowX - minEditorWidth(), e_5);
                    const dispatch_1 = dispatch;
                    dispatch_1(new Msg(/* UpdateModel */ 41, [(model_1) => {
                        const w_3 = w_1 | 0;
                        const model_2 = model_1;
                        const wsModel = getWSModel_1(model_2);
                        const namesColWidth = calcNamesColWidth(wsModel) | 0;
                        const otherDivWidths = (((leftMargin + rightMargin) + Constants_dividerBarWidth_1) + waveTableRightGap) | 0;
                        const valuesColumnWidth = valuesColumnSize(wsModel)[0] | 0;
                        const waveColWidth = (((w_3 - otherDivWidths) - namesColWidth) - valuesColumnWidth) | 0;
                        let wholeCycles;
                        const _arg_1 = max(1, min(~~(wsModel.WSConfig.LastClock / wsModel.SamplingZoom), ~~(waveColWidth / singleWaveWidth(wsModel)))) | 0;
                        wholeCycles = ((Math.abs((_arg_1 - wsModel.ShownCycles) / wsModel.ShownCycles) < 0.1) ? wsModel.ShownCycles : _arg_1);
                        const finalWavesColWidth = (waveColWidth / wholeCycles) * wholeCycles;
                        const scrollbarWidth = ((namesColWidth + finalWavesColWidth) + valuesColumnWidth) - viewSymbolWidth;
                        return updateWSModel((wsModel_1) => {
                            const lastSampledCycle = ~~(wsModel_1.WSConfig.LastClock / wsModel_1.SamplingZoom) | 0;
                            return ((w_3 !== model_2.WaveSimViewerWidth) ? (validateScrollBarInfo) : ((x) => x))(new WaveSimModel(wsModel_1.DefaultCursor, wsModel_1.WSConfig, wsModel_1.WSConfigDialog, wsModel_1.State, wsModel_1.WaveDetails, wsModel_1.SelectedWaves, wsModel_1.DefaultSelectionPending, wsModel_1.FetchFailedAtMs, min(wsModel_1.StartCycle, max(0, (lastSampledCycle - wholeCycles) + 1)), wholeCycles, wsModel_1.SamplingZoom, min(wsModel_1.CursorDisplayCycle, lastSampledCycle), min(wsModel_1.CursorExactClkCycle, wsModel_1.WSConfig.LastClock), wsModel_1.ClkCycleBoxIsEmpty, wsModel_1.Radix, finalWavesColWidth, wsModel_1.WaveModalActive, wsModel_1.RamModalActive, wsModel_1.PortSelectComp, wsModel_1.RamComps, wsModel_1.SelectedRams, wsModel_1.RamStartLocation, wsModel_1.RamRows, wsModel_1.ShowSheetDetail, wsModel_1.SelectedSheetInstance, wsModel_1.ShowGroupDetail, wsModel_1.HoveredLabel, wsModel_1.DraggedIndex, wsModel_1.PrevSelectedWaves, wsModel_1.ScrollbarTbWidth, wsModel_1.ScrollbarTbPos, wsModel_1.ScrollbarTbOffset, scrollbarWidth, wsModel_1.ScrollbarBkgRepCycs, wsModel_1.ScrollbarQueueIsEmpty, wsModel_1.SheetSearchString, wsModel_1.ComponentSearchString, wsModel_1.PortSearchString, wsModel_1.ShowOnlySelected));
                        }, new Model(model_2.WindowWidth, model_2.KeyFocusPane, model_2.RunAfterRenderWithSpinner, model_2.UserData, model_2.WaveSim, model_2.WaveSimSheet, model_2.UISheetTrail, model_2.Spinner, model_2.Sheet, model_2.IsLoading, model_2.LastChangeCheckTime, model_2.LastSimulatedCanvasState, model_2.LastDetailedSavedState, model_2.CurrentSelected, model_2.LastSelectedIds, model_2.LastUsedDialogWidth, model_2.SelectedComponent, model_2.CurrentStepSimulationStep, model_2.CurrentTruthTable, model_2.TTConfig, model_2.RightPaneTabVisible, model_2.SimSubTabVisible, model_2.CircuitCheck, model_2.Hilighted, model_2.Clipboard, model_2.LastCreatedComponent, model_2.SavedSheetIsOutOfDate, model_2.PendingDragAddition, model_2.DragPlacement, model_2.ProjectBrowser, model_2.TopSheetChoiceDeclined, model_2.ComponentLibraries, model_2.OpenLibrary, model_2.CatalogueSearch, model_2.ArrayCopiesTyped, model_2.SimulateInRenderer, model_2.SidecarSession, model_2.ProbeRead, model_2.SidecarInFlight, model_2.SidecarBuildEndedMs, model_2.SidecarRunEndedMs, model_2.StepRunTarget, model_2.FetchedData, model_2.FetchedStructure, model_2.FailedFetch, model_2.StimulusGeneration, model_2.CurrentViewport, model_2.ViewportChangedAtMs, model_2.WaveScrollSettling, model_2.WaveScrollSerial, model_2.ShowLibrarySheets, model_2.SuppressErrorPopups, model_2.OpenedLibrarySheets, model_2.ReadOnlyBaseline, model_2.CurrentProj, model_2.PopupViewFunc, model_2.SpinnerPayload, model_2.PopupDialogData, model_2.Notifications, model_2.TopMenuOpenState, model_2.SheetMenuPinned, model_2.DividerDragMode, w_3, model_2.ConnsOfSelectedWavesAreHighlighted, model_2.Pending, model_2.UIState, model_2.BuildVisible, model_2.CodeEditorState));
                    }]));
                    dispatch_1(Msg.GenerateCurrentWaveforms);
                    dispatch(new Msg(/* SetDragMode */ 88, [DragMode.DragModeOff]));
                    dispatch(new Msg(/* SetViewerWidth */ 99, [w_1]));
                    break;
                }
                case 2: {
                    break;
                }
            }
        }]), new DOMAttr(/* OnClick */ 40, [(topMenu = model.TopMenuOpenState, (ev_1) => {
            let matchResult_1;
            switch (topMenu.tag) {
                case 1:
                case 3:
                case 4: {
                    matchResult_1 = 1;
                    break;
                }
                case 0:
                case 5: {
                    matchResult_1 = 2;
                    break;
                }
                default:
                    if (model.SheetMenuPinned) {
                        matchResult_1 = 0;
                    }
                    else {
                        matchResult_1 = 1;
                    }
            }
            switch (matchResult_1) {
                case 0: {
                    break;
                }
                case 1: {
                    dispatch(new Msg(/* SetTopMenu */ 85, [TopMenu.Closed]));
                    break;
                }
                case 2: {
                    break;
                }
            }
        })]), new DOMAttr(/* OnMouseUp */ 57, [(ev_2) => {
            if (ev_2.buttons === 1) {
                dispatch(Msg.SelectionHasChanged);
            }
            const matchValue_5 = ev_2.buttons;
            let matchResult_2, pos_2, pos_3;
            if (dividerDragMode.tag === 0) {
                if (matchValue_5 === 1) {
                    matchResult_2 = 1;
                    pos_3 = dividerDragMode.fields[0];
                }
                else {
                    matchResult_2 = 1;
                    pos_3 = dividerDragMode.fields[0];
                }
            }
            else {
                matchResult_2 = 2;
            }
            switch (matchResult_2) {
                case 0: {
                    const newWidth_2 = ((wsViewerWidth - ~~ev_2.clientX) + pos_2) | 0;
                    let w_4;
                    const e_9 = max(minViewerWidth, newWidth_2) | 0;
                    w_4 = min(windowX - minEditorWidth(), e_9);
                    dispatch(new Msg(/* SetDragMode */ 88, [new DragMode(/* DragModeOn */ 0, [(~~ev_2.clientX - w_4) + newWidth_2])]));
                    dispatch(new Msg(/* SetViewerWidth */ 99, [w_4]));
                    break;
                }
                case 1: {
                    let w_5;
                    const e_12 = max(minViewerWidth, (wsViewerWidth - ~~ev_2.clientX) + pos_3) | 0;
                    w_5 = min(windowX - minEditorWidth(), e_12);
                    const dispatch_3 = dispatch;
                    dispatch_3(new Msg(/* UpdateModel */ 41, [(model_3) => {
                        const w_7 = w_5 | 0;
                        const model_4 = model_3;
                        const wsModel_2 = getWSModel_1(model_4);
                        const namesColWidth_1 = calcNamesColWidth(wsModel_2) | 0;
                        const otherDivWidths_1 = (((leftMargin + rightMargin) + Constants_dividerBarWidth_1) + waveTableRightGap) | 0;
                        const valuesColumnWidth_1 = valuesColumnSize(wsModel_2)[0] | 0;
                        const waveColWidth_1 = (((w_7 - otherDivWidths_1) - namesColWidth_1) - valuesColumnWidth_1) | 0;
                        let wholeCycles_1;
                        const _arg_2 = max(1, min(~~(wsModel_2.WSConfig.LastClock / wsModel_2.SamplingZoom), ~~(waveColWidth_1 / singleWaveWidth(wsModel_2)))) | 0;
                        wholeCycles_1 = ((Math.abs((_arg_2 - wsModel_2.ShownCycles) / wsModel_2.ShownCycles) < 0.1) ? wsModel_2.ShownCycles : _arg_2);
                        const finalWavesColWidth_1 = (waveColWidth_1 / wholeCycles_1) * wholeCycles_1;
                        const scrollbarWidth_1 = ((namesColWidth_1 + finalWavesColWidth_1) + valuesColumnWidth_1) - viewSymbolWidth;
                        return updateWSModel((wsModel_1_1) => {
                            const lastSampledCycle_1 = ~~(wsModel_1_1.WSConfig.LastClock / wsModel_1_1.SamplingZoom) | 0;
                            return ((w_7 !== model_4.WaveSimViewerWidth) ? (validateScrollBarInfo) : ((x_1) => x_1))(new WaveSimModel(wsModel_1_1.DefaultCursor, wsModel_1_1.WSConfig, wsModel_1_1.WSConfigDialog, wsModel_1_1.State, wsModel_1_1.WaveDetails, wsModel_1_1.SelectedWaves, wsModel_1_1.DefaultSelectionPending, wsModel_1_1.FetchFailedAtMs, min(wsModel_1_1.StartCycle, max(0, (lastSampledCycle_1 - wholeCycles_1) + 1)), wholeCycles_1, wsModel_1_1.SamplingZoom, min(wsModel_1_1.CursorDisplayCycle, lastSampledCycle_1), min(wsModel_1_1.CursorExactClkCycle, wsModel_1_1.WSConfig.LastClock), wsModel_1_1.ClkCycleBoxIsEmpty, wsModel_1_1.Radix, finalWavesColWidth_1, wsModel_1_1.WaveModalActive, wsModel_1_1.RamModalActive, wsModel_1_1.PortSelectComp, wsModel_1_1.RamComps, wsModel_1_1.SelectedRams, wsModel_1_1.RamStartLocation, wsModel_1_1.RamRows, wsModel_1_1.ShowSheetDetail, wsModel_1_1.SelectedSheetInstance, wsModel_1_1.ShowGroupDetail, wsModel_1_1.HoveredLabel, wsModel_1_1.DraggedIndex, wsModel_1_1.PrevSelectedWaves, wsModel_1_1.ScrollbarTbWidth, wsModel_1_1.ScrollbarTbPos, wsModel_1_1.ScrollbarTbOffset, scrollbarWidth_1, wsModel_1_1.ScrollbarBkgRepCycs, wsModel_1_1.ScrollbarQueueIsEmpty, wsModel_1_1.SheetSearchString, wsModel_1_1.ComponentSearchString, wsModel_1_1.PortSearchString, wsModel_1_1.ShowOnlySelected));
                        }, new Model(model_4.WindowWidth, model_4.KeyFocusPane, model_4.RunAfterRenderWithSpinner, model_4.UserData, model_4.WaveSim, model_4.WaveSimSheet, model_4.UISheetTrail, model_4.Spinner, model_4.Sheet, model_4.IsLoading, model_4.LastChangeCheckTime, model_4.LastSimulatedCanvasState, model_4.LastDetailedSavedState, model_4.CurrentSelected, model_4.LastSelectedIds, model_4.LastUsedDialogWidth, model_4.SelectedComponent, model_4.CurrentStepSimulationStep, model_4.CurrentTruthTable, model_4.TTConfig, model_4.RightPaneTabVisible, model_4.SimSubTabVisible, model_4.CircuitCheck, model_4.Hilighted, model_4.Clipboard, model_4.LastCreatedComponent, model_4.SavedSheetIsOutOfDate, model_4.PendingDragAddition, model_4.DragPlacement, model_4.ProjectBrowser, model_4.TopSheetChoiceDeclined, model_4.ComponentLibraries, model_4.OpenLibrary, model_4.CatalogueSearch, model_4.ArrayCopiesTyped, model_4.SimulateInRenderer, model_4.SidecarSession, model_4.ProbeRead, model_4.SidecarInFlight, model_4.SidecarBuildEndedMs, model_4.SidecarRunEndedMs, model_4.StepRunTarget, model_4.FetchedData, model_4.FetchedStructure, model_4.FailedFetch, model_4.StimulusGeneration, model_4.CurrentViewport, model_4.ViewportChangedAtMs, model_4.WaveScrollSettling, model_4.WaveScrollSerial, model_4.ShowLibrarySheets, model_4.SuppressErrorPopups, model_4.OpenedLibrarySheets, model_4.ReadOnlyBaseline, model_4.CurrentProj, model_4.PopupViewFunc, model_4.SpinnerPayload, model_4.PopupDialogData, model_4.Notifications, model_4.TopMenuOpenState, model_4.SheetMenuPinned, model_4.DividerDragMode, w_7, model_4.ConnsOfSelectedWavesAreHighlighted, model_4.Pending, model_4.UIState, model_4.BuildVisible, model_4.CodeEditorState));
                    }]));
                    dispatch_3(Msg.GenerateCurrentWaveforms);
                    dispatch(new Msg(/* SetDragMode */ 88, [DragMode.DragModeOff]));
                    dispatch(new Msg(/* SetViewerWidth */ 99, [w_5]));
                    break;
                }
                case 2: {
                    break;
                }
            }
        }]), ["style", {
            cursor: cursorText,
            userSelect: "none",
            borderTop: "2px solid lightgray",
            borderBottom: "2px solid lightgray",
            Overflow: "clip clip",
            height: "calc(100%-4px)",
        }]];
        const children_10 = toList(delay(() => append_1(singleton_1(viewPopup(model, dispatch)), delay(() => append_1(singleton_1(viewDragGhost(model)), delay(() => {
            let children_4;
            const claimKeyFocus = (pane) => {
                if (!equals(model.KeyFocusPane, pane)) {
                    dispatch(new Msg(/* UpdateModel */ 41, [(m) => (new Model(m.WindowWidth, pane, m.RunAfterRenderWithSpinner, m.UserData, m.WaveSim, m.WaveSimSheet, m.UISheetTrail, m.Spinner, m.Sheet, m.IsLoading, m.LastChangeCheckTime, m.LastSimulatedCanvasState, m.LastDetailedSavedState, m.CurrentSelected, m.LastSelectedIds, m.LastUsedDialogWidth, m.SelectedComponent, m.CurrentStepSimulationStep, m.CurrentTruthTable, m.TTConfig, m.RightPaneTabVisible, m.SimSubTabVisible, m.CircuitCheck, m.Hilighted, m.Clipboard, m.LastCreatedComponent, m.SavedSheetIsOutOfDate, m.PendingDragAddition, m.DragPlacement, m.ProjectBrowser, m.TopSheetChoiceDeclined, m.ComponentLibraries, m.OpenLibrary, m.CatalogueSearch, m.ArrayCopiesTyped, m.SimulateInRenderer, m.SidecarSession, m.ProbeRead, m.SidecarInFlight, m.SidecarBuildEndedMs, m.SidecarRunEndedMs, m.StepRunTarget, m.FetchedData, m.FetchedStructure, m.FailedFetch, m.StimulusGeneration, m.CurrentViewport, m.ViewportChangedAtMs, m.WaveScrollSettling, m.WaveScrollSerial, m.ShowLibrarySheets, m.SuppressErrorPopups, m.OpenedLibrarySheets, m.ReadOnlyBaseline, m.CurrentProj, m.PopupViewFunc, m.SpinnerPayload, m.PopupDialogData, m.Notifications, m.TopMenuOpenState, m.SheetMenuPinned, m.DividerDragMode, m.WaveSimViewerWidth, m.ConnsOfSelectedWavesAreHighlighted, m.Pending, m.UIState, m.BuildVisible, m.CodeEditorState))]));
                }
            };
            return append_1(equals(model.PopupDialogData.Progress, undefined) ? singleton_1((children_4 = [view(model.Sheet, headerHeight, canvasVisibleStyleList(model), Probe_view(model), hoveredHighlight(model), (sMsg) => {
                dispatch(new Msg(/* Sheet */ 3, [sMsg]));
            })], react.createElement("div", {
                onMouseDown: (_arg_3) => {
                    claimKeyFocus(Pane.LeftPane);
                },
            }, ...children_4))) : empty_1(), delay(() => append_1(singleton_1(viewNotifications(model, dispatch)), delay(() => {
                getWSModel(model);
                return !equals(model.PopupDialogData.Progress, undefined) ? singleton_1(react.createElement("div", {})) : append_1(singleton_1(viewTopMenu(model, dispatch)), delay(() => append_1(singleton_1(viewCanvasTopOverlay(model)), delay(() => append_1(singleton_1(viewOnDiagramButtons(model, dispatch)), delay(() => {
                    let props_8, children_8;
                    return singleton_1((props_8 = [new HTMLAttr(/* Id */ 99, ["RightSection"]), rightSectionStyle(model), new DOMAttr(/* OnMouseDown */ 51, [(_arg_4) => {
                        claimKeyFocus(Pane.RightPane);
                    }]), new DOMAttr(/* OnMouseMove */ 54, [(event) => {
                        const leftButtonIsdown = (~~event.buttons & 1) !== 0;
                        const inDrag = offsetOpt != null;
                        if (inDrag && !leftButtonIsdown) {
                            dispatch(new Msg(/* ScrollbarMouseMsg */ 122, [event.clientX, ScrollbarMouseAction.ClearScrollbarDrag, dispatch]));
                        }
                        else if (inDrag) {
                            dispatch(new Msg(/* ScrollbarMouseMsg */ 122, [event.clientX, ScrollbarMouseAction.InScrollbarDrag, dispatch]));
                        }
                    }]), new DOMAttr(/* OnMouseUp */ 57, [(event_1) => {
                        if (offsetOpt != null) {
                            dispatch(new Msg(/* ScrollbarMouseMsg */ 122, [event_1.clientX, ScrollbarMouseAction.ClearScrollbarDrag, dispatch]));
                        }
                    }])], (children_8 = [dividerbar(model, dispatch), viewRightTabs(canvasState[0], canvasState[1], model, dispatch)], react.createElement("div", keyValueList(props_8, 1), ...children_8))));
                }))))));
            }))));
        }))))));
        return react.createElement("div", keyValueList(props_10, 1), ...children_10);
    }
}

